import ContentManager from './base';
import Panel from '../panels';
import flash from '../flash';
import Utils from '../utils';

export default class PasswordContentViewer extends ContentManager {
  constructor(context, remote, options) {
    super(context, remote, options);
  }

  loadModal() {
    return this.load().then((data) => {
      this.panel = new Panel(Panel.HUB, data, {
        fullscreen: this.options.fullscreen,
      });
      return this.panel;
    });
  }

  validatePassword() {
    return this.remote
      .put('learn/' + this.options.session_id + '/node/' + this.context.getId() + '/unlock', {
        code: this.panel.content.find('.lp--js-passwordPanelInput').val(),
      })
      .then((res) => {
        if (res.unlocked) {
          this.options.node.data('lock_state', 'unlocked');
          this.options.onResolve(this.options.node);
          flash(i18n.__('node_unlock_success'), { ttl: 3000, type: 'status' });
        } else {
          flash(i18n.__('node_unlock_failed'), { ttl: 3000 });
        }
      });
  }

  parseResult(content) {
    let cnt = $(content);

    cnt.find('.lp--js-passwordPanelInput').on('keyup', (ev) => {
      if (ev.keyCode == 13) {
        this.validatePassword();
      }
    });

    cnt.find('.lp--js-openBtn').on(Utils.interactionEvent, (ev) => {
      this.validatePassword();
    });
    return cnt;
  }

  load() {
    return new Promise((resolve, reject) => {
      let cnt = Handlebars.templates['password_panel']({
        name: this.context.getName(),
      });
      resolve(this.parseResult(cnt));
    }).catch(function (err) {
      flash(i18n.__('error_behavior_load_failed'));
    });
  }
}
